import Team6 from './Team6'
export default Team6
